import type { ActionListProps } from '@shopify/polaris';

import { ActionList, Button, Popover, Text } from '@shopify/polaris';
import { CAMPAIGN_ANALYTIC_MAPPING } from '../../constants';
import { useHandleSwitchMetric } from '../../hooks';
import { EditIcon } from '@shopify/polaris-icons';
import { ICampaignMetricKey } from '../../types';
import { GTooltip } from '~/presentation/ui';
import { useMemo } from 'react';

export interface AnalyticSwitchMetricProps {
  positionMetricShowing: number;
  active: boolean;
  toggleActive: () => void;
}

export const METRIC_SUPPORT_SWITCH: ICampaignMetricKey[] = [
  ICampaignMetricKey.SESSION,
  ICampaignMetricKey.VISITOR,
  ICampaignMetricKey.ORDER,
  ICampaignMetricKey.REVENUE,
  ICampaignMetricKey.AOV,
  ICampaignMetricKey.CONVERSION_RATE,
  ICampaignMetricKey.RPV,
  ICampaignMetricKey.CTR,
  ICampaignMetricKey.AVG_TIME,
  ICampaignMetricKey.PAGE_VIEWED,
  ICampaignMetricKey.BOUNCE_RATE,
];

export const AnalyticSwitchMetric: React.FC<AnalyticSwitchMetricProps> = ({
  positionMetricShowing,
  toggleActive,
  active,
}) => {
  const { metricShowing, handleMetricShowingChange } = useHandleSwitchMetric();

  const activator = useMemo(() => {
    return (
      <GTooltip
        content={
          <div className="whitespace-nowrap w-fit">
            <Text as="span">{'Switch metric'}</Text>
          </div>
        }
        isEnabled={true}
      >
        <div className="w-[28px] h-[28px] flex items-center justify-center">
          <Button
            size="slim"
            loading={false}
            variant="tertiary"
            icon={EditIcon}
            onClick={toggleActive}
          ></Button>
        </div>
      </GTooltip>
    );
  }, [toggleActive]);

  const combineActionList = useMemo(() => {
    const data = CAMPAIGN_ANALYTIC_MAPPING.filter((item) => {
      return (
        !metricShowing?.find((metric) => metric.metricKey === item.metricKey) &&
        METRIC_SUPPORT_SWITCH.includes(item.metricKey)
      );
    });
    const actionList: ActionListProps['items'] = data.map((item) => {
      return {
        content: item.title,
        onAction: () => {
          handleMetricShowingChange({
            metricKey: item.metricKey,
            position: positionMetricShowing,
          });
          toggleActive();
        },
      };
    });

    return actionList;
  }, [handleMetricShowingChange, metricShowing, positionMetricShowing, toggleActive]);

  return (
    <div style={{ display: 'flex', height: '28px' }}>
      <Popover
        // activatorWrapper="tooltip-content"
        fullHeight
        active={active}
        activator={activator}
        fluidContent
        autofocusTarget="container"
        onClose={toggleActive}
        preventFocusOnClose
        preventCloseOnChildOverlayClick
      >
        <div className={'Polaris-GActionList w-[300px]'} onClick={(e) => e && e.stopPropagation()}>
          <ActionList items={combineActionList} />
        </div>
      </Popover>
    </div>
  );
};
